<div class="prize-weights-filter">
  <div class="section-header">
    <div class="section-title">
      <h4>{{ sectionTitle }}</h4>
      <i
        class="pi pi-info-circle tooltip-info-icon"
        pTooltip="Percentages in this section must add up to 100%."
        tooltipPosition="top"
      ></i>
    </div>
    <span class="guardrail-tag">Max {{ maxOccurrencesPerCategory }} per category</span>
  </div>

  <div class="weight-rows" *ngIf="rowsForm">
    <div class="weight-row" *ngFor="let row of rows; let i = index" [formGroup]="row">
      <p-dropdown
        [options]="categoryOptions"
        optionLabel="name"
        optionValue="_id"
        formControlName="categoryRef"
        placeholder="Select category"
        [filter]="true"
        filterBy="name"
        [autoDisplayFirst]="false"
        [style]="{ width: '100%' }"
        (onChange)="onCategorySelected(row)"
      ></p-dropdown>

      <p-inputNumber
        formControlName="weight"
        [min]="0"
        [max]="100"
        [maxFractionDigits]="2"
        suffix="%"
        [style]="{ width: '100%' }"
      ></p-inputNumber>

      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-danger remove-row-btn"
        pTooltip="Remove category"
        tooltipPosition="top"
        (click)="removeCategory(i)"
      ></button>
    </div>
  </div>

  <button
    pButton
    pRipple
    type="button"
    label="Add Category"
    icon="pi pi-plus"
    class="p-button-text p-button-sm add-category-btn"
    (click)="addCategory()"
  ></button>

  <div class="weight-total-badge" [ngClass]="{ 'is-balanced': isBalanced, 'is-unbalanced': !isBalanced }">
    <i class="pi" [ngClass]="isBalanced ? 'pi-check-circle' : 'pi-exclamation-triangle'"></i>
    Total: {{ total }}%
    <span *ngIf="!isBalanced">(must equal {{ requiredTotal }}%)</span>
  </div>
</div>
